// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './app'
import router from './router'
import store from './store'
import config from './assets/js/config'
import './assets/css/tailwind.css'

Vue.config.productionTip = false

function initVue () {
  const apolloProvider = require('./init/apollo').default
  let Apps = Vue.component('app', App)
  new Apps({
    el: '#app',
    router,
    store,
    apolloProvider
  })
  setTimeout(() => {
    let loadCover = document.getElementById('loading')
    if (loadCover) loadCover.className += ' completed'
  }, 400)
}
async function init () {
  for (let i of config.initPlugins) {
    let p
    if (typeof i === 'object') {
      if (i.env !== config.env) continue
      p = require('./init/' + i.name)
    } else {
      p = require('./init/' + i)
    }
    if (p && p.default && typeof p.default === 'function') {
      await p.default()
    }
  }
  initVue()
}
init()
